var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsFill0Azul(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.127,
    height: 6.293,
    viewBox: "0 0 11.127 6.293",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chevron_right_FILL0_azul",
    d: "M.208,10.919A.9.9,0,0,1,0,10.384a.659.659,0,0,1,.207-.511L4.492,5.588.183,1.279A.67.67,0,0,1,0,.755.749.749,0,0,1,.208.232.687.687,0,0,1,.731,0a.735.735,0,0,1,.5.231L6.074,5.077a.742.742,0,0,1,.17.243.761.761,0,0,1,0,.536.742.742,0,0,1-.17.243l-4.82,4.82a.659.659,0,0,1-.511.207A.9.9,0,0,1,.208,10.919Z",
    transform: "translate(11.127) rotate(90)",
    fill: "#263a5b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsFill0Azul);
export default __webpack_public_path__ + "static/media/icons_FILL0_azul.a8119d9839404c3424f10def780b4581.svg";
export { ForwardRef as ReactComponent };